import { type AccessibilityRole, Platform, StyleSheet, View } from 'react-native';

import { InlineAlert, Text, tokens } from '@fhs/ui';
import { CHECKOUT_ORDER_SUMMARY_HEADING } from '@fhs-legacy/frontend/src/utils/test-ids';

import { useCartStore } from '../../../state/cart-store';
import { CHECKOUT_ORDER_SUMMARY_TITLE_NATIVE_ID } from '../../checkout-a11y';

import DeliveryFees from './delivery-fees';
import { TipRow } from './delivery-tips/tips-row';
import DiscountRow from './discount-row';
import DonationRow from './donation-row';
import EstimatedPointsRow from './estimated-points-row';
import SubtotalRow from './subtotal-row';
import TaxRow from './tax-row';
import TotalRow from './total-row';

export function CheckoutOrderSummary() {
  const { cartEntries } = useCartStore();
  const cartIsEmpty = cartEntries.length < 1;

  if (cartIsEmpty) {
    return (
      <InlineAlert
        type="error"
        message="Your cart is empty, add some items to the cart and come back to checkout."
      />
    );
  }
  return (
    <View
      style={styles.section}
      {...(Platform.OS === 'web'
        ? ({
            accessibilityRole: 'region' as AccessibilityRole,
            accessibilityLabelledBy: CHECKOUT_ORDER_SUMMARY_TITLE_NATIVE_ID,
          } as const)
        : {})}
    >
      <Text.Heading
        type="four"
        style={styles.heading}
        testID={CHECKOUT_ORDER_SUMMARY_HEADING}
        nativeID={CHECKOUT_ORDER_SUMMARY_TITLE_NATIVE_ID}
        accessibilityLevel={3}
        tabIndex={Platform.OS === 'web' ? 0 : undefined}
      >
        Order Summary
      </Text.Heading>
      <SubtotalRow />
      <DonationRow />
      <DiscountRow />
      <TaxRow />
      <DeliveryFees />
      <TipRow />
      <View
        style={styles.separator}
        accessibilityRole="none"
        importantForAccessibility="no-hide-descendants"
      />
      <TotalRow />
      <EstimatedPointsRow />
    </View>
  );
}
const styles = StyleSheet.create({
  section: {
    alignSelf: 'stretch',
  },
  heading: {
    marginTop: 20,
    marginBottom: 12,
    marginHorizontal: 28,
  },
  separator: {
    height: 1,
    backgroundColor: tokens.colors.$blackOpacity10,
    marginHorizontal: 28,
    marginVertical: 16,
  },
});
